/**
 * This file was auto-generated by client-types. Do not manually edit this file.
 * Your changes would be automatically overwritten.
 *
 * Service Documentation: https://private.hubteam.com/shoebill/service/com.hubspot.mylearning.bff.rpc.MyLearningBFFChirpService
 */

export const getProgressItemsForMyLearningPageRpc = {
  serviceName: 'com.hubspot.mylearning.bff.rpc.MyLearningBFFChirpService',
  rpcName: 'getProgressItemsForMyLearningPage',
  auth: 'app',
  fingerprint: 'IQ7FLFouw3-VLfxVFH6LwBhHUn3ip_ng',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};